import type { Key } from 'react';
import { useEffect, useState } from 'react';

import {
	Label,
	SliderWrapper,
	StyledSlider,
	StyledThumb,
	StyledTrack,
	ThumbWrapper,
} from './styles';

interface DeferredSliderProps {
	value: [number, number];
	min: number;
	max: number;
	onChange: (value: [number, number]) => void;
}

export const Slider = ({ value, min, max, onChange }: DeferredSliderProps) => {
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	const Track = (
		{ key, ...props }: { key?: Key | null },
		state: { index: number }
	) => <StyledTrack key={key} {...props} index={state.index} />;
	const Thumb = ({ key, ...props }: { key?: Key | null }) => (
		<ThumbWrapper key={key} {...props}>
			<StyledThumb />
		</ThumbWrapper>
	);

	return (
		<SliderWrapper>
			<Label align="left">{value[0]}</Label>
			<StyledSlider
				renderThumb={Thumb}
				renderTrack={Track}
				value={localValue}
				min={min}
				max={max}
				onChange={(value) => {
					setLocalValue(value);
					onChange(value);
				}}
			/>
			<Label align="right">
				{value[1] === max ? `${value[1]}+` : value[1]}
			</Label>
		</SliderWrapper>
	);
};
